import React from "react";
import ConsentCheckboxRow from "components/common/consent/ConsentCheckboxRow";
import { useLocale } from "lib/hooks/useLocale";
import { ConsentForm } from "lib/hooks/useConsentForm";

interface ConsentCheckboxesProps {
  consentForm: ConsentForm;
  className?: string;
}

/**
 * The login screen checkboxes: the main one for every listed consent (with
 * Manage preferences), then MARKETING on its own, which turns all its channels
 * on or off together.
 */
const ConsentCheckboxes: React.FC<ConsentCheckboxesProps> = ({ consentForm, className }) => {
  const { t } = useLocale();
  const { visibleConsents, isAllAccepted, setAllAccepted, openPreferences } = consentForm;
  const { marketingConsent, isMarketingVisible, isMarketingAccepted, setMarketingAccepted } = consentForm;

  return (
    <>
      {visibleConsents.length > 0 && (
        <ConsentCheckboxRow
          id="flo__consent__checkbox"
          label={t("consent_allow_cookies")}
          checked={isAllAccepted}
          onCheckedChange={setAllAccepted}
          onManagePreferences={openPreferences}
          className={className}
        />
      )}
      {isMarketingVisible && marketingConsent && (
        <ConsentCheckboxRow
          id="flo__consent__marketing_checkbox"
          label={marketingConsent.description || t("consent_marketing_fallback")}
          checked={isMarketingAccepted}
          onCheckedChange={setMarketingAccepted}
          className={className}
        />
      )}
    </>
  );
};

export default ConsentCheckboxes;
